<script setup>
// Uma opção (role="radio") das perguntas da aba Kanban do modal de papéis.
// Atributos extras (data-kanban-*) caem no botão.
defineProps({
  selected: { type: Boolean, default: false },
  label: { type: String, required: true },
  hint: { type: String, default: '' },
});

defineEmits(['select']);
</script>

<template>
  <button
    type="button"
    role="radio"
    :aria-checked="selected"
    class="flex items-start gap-2 rounded-lg border p-2.5 text-left transition-colors"
    :class="
      selected
        ? 'border-n-iris-9 bg-n-solid-1 ring-1 ring-n-iris-9'
        : 'border-n-weak bg-n-alpha-1 hover:border-n-slate-8'
    "
    @click="$emit('select')"
  >
    <span
      class="mt-0.5 flex size-3.5 flex-shrink-0 items-center justify-center rounded-full border"
      :class="selected ? 'border-n-iris-9' : 'border-n-slate-8'"
    >
      <span v-if="selected" class="size-2 rounded-full bg-n-iris-9" />
    </span>
    <span class="flex flex-col gap-0.5">
      <span
        class="text-sm font-medium"
        :class="selected ? 'text-n-iris-11' : 'text-n-slate-12'"
      >
        {{ label }}
      </span>
      <span v-if="hint" class="text-xs leading-snug text-n-slate-11">
        {{ hint }}
      </span>
    </span>
  </button>
</template>
